import { makeStyles, withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  card: {
    marginTop: '10px',
  },
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  container: {
    width: '48%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px',
    alignItems: 'center',
  },
  titles: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    fontWeight: 'Bold',
    color: '#FAA500',
  },
  description: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '14px',
    fontWeight: 'Bold',
  },
  userContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    borderBottom: '1px solid #80808059',
  },
}));

export const Input = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #FAA500',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Nunito',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#FAA500',
      boxShadow: '0 0 0 0.2rem rgb(255 154 0 / 50%)',
    },
  },
}))(InputBase);
